<template>
    <div>
        <sponsor />
        <div class="bg-primary-orange text-center p-5 text-sm">
            <router-link to="/staticweb/2">
                Impressum
            </router-link>
            |
            <router-link to="/staticweb/3">
                Datenschutz
            </router-link>
            |
            <router-link to="/staticweb/4">
                Kontakt
            </router-link>
        </div>
    </div>

</template>

<script>

    import sponsor from '../sponsors/sponsors'


    export default {
        name: 'Footer',
        components: {
            sponsor
        },
        data() {
            return {

            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {
                }
            }
        }
    }
</script>

<style>
    .sepWrap{
        vertical-align: top;
        margin: 0;
        height: 0;
        line-height: 1px;
    }
</style>
